export default __webpack_public_path__ + "search.3274eb1e.svg";